<template>
  <div>
    <navlist :navlist="about" :show='false' />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />党建
        </h1>
        <h2>主题党日活动</h2>
      </div>
      <div class="main">
        
        <h3 style="text-align:center; ">{{title}}</h3>
         <div v-html="content"></div>
      </div>
      
    </div>
  </div>
</template>

<script>
import news from "../components/news";
import navlist from "../components/nav";
import {getArticleContent} from '../api/index'
export default {
  name:'partydetail',
  components: {
    navlist,
    news
  },
  data() {
    return {
      about: [
         {
          path: "/party/member",
          name: "在册党员"
        },
        {
          path: "/party/grid",
          name: "红色网格"
        },
        {
          path: "/party/activity",
          name: "主题党日活动"
        },
        {
          path: "/party/platform",
          name: "党员学习平台"
        }
      ],
   
      local: "",
      title:'',
      content:'',
      id: this.$route.params.detail
    };
  },
  created() {
    this.showlocal(this.$route);
    this.getContent()
  },
  watch: {
    $route(to) {
      this.showlocal(to);
    }
  },
  methods: {
    showlocal(to) {
      const local = this.about.filter(item => {
        if(item.path.indexOf(to.params.id)>=0){
          return item
        }
      });
    },
    async getContent(){
      let {id} =this
      let {data} = await getArticleContent({id})
      
      this.content = data.data.content
      this.title = data.data.title
    }
  }
};
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>